import './app.less';

const ua = navigator.userAgent;
const isMobile = !!ua.match(/AppleWebKit.*Mobile.*/);
if (isMobile) {
  location.href = '/index.html';
}

import config from '../config';
import mark from '../mark';
import '../user';

const accountUrl = config.accountUrl;
const apiUrl = config.apiUrl;
const caimiUrl = config.caimiUrl;
const facedetectUrl = config.facedetectUrl;
const httpProtocol = config.httpProtocol;
const loginDirect = config.loginDirect;
const registerDirect = config.registerDirect;
const webUrl = config.webUrl;
const staticUrl = config.staticUrl;
const authDocs = config.authDocs;
const spmMark = 'xhzy_mp_index';

// 设置跳转链接
const urlArr = [
  {
    name: 'LoginUrl',
    url: `${loginDirect}${encodeURIComponent(location.href)}`
  }, {
    name: 'RegisterUrl',
    url: `${registerDirect}${encodeURIComponent(location.href)}`
  }, {
    name: 'CopyrightLogin',
    url: `${loginDirect}${encodeURIComponent(`${httpProtocol}${webUrl}/banquan/all?from=${spmMark}`)}`
  }, {
    name: 'TTSLoginUrl',
    url: `${loginDirect}${encodeURIComponent(`${httpProtocol}${webUrl}/tts?from=${spmMark}`)}`
  }, {
    name: 'FenfaLoginUrl',
    url: `${loginDirect}${encodeURIComponent(`${httpProtocol}${webUrl}/fenfa?from=${spmMark}`)}`
  }, {
    name: 'CaimiUrl',
    url: `${caimiUrl}?from=${spmMark}`
  }, {
    name: 'FaceDetectUrl',
    url: `${facedetectUrl}?from=${spmMark}`
  }, {
    name: 'LiveUrl',
    url: `${loginDirect}${encodeURIComponent(`${httpProtocol}${webUrl}/persona?from=${spmMark}`)}`
  }
];

urlArr.map((item) => {
  $('.' + item.name).attr('href', item.url);
});

$('.product-item').click((e) => {
  const hasMobile = $(e.currentTarget).hasClass('mobile');
  $('.product-item').removeClass('mobile');
  if (hasMobile) return;
  $(e.currentTarget).addClass('mobile');
})

var userAgent = navigator.userAgent;
var isOpera = userAgent.indexOf("Opera") > -1;
var isIE = userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1 && !isOpera;
if (isIE) {
  $('.downloadDocs').attr('href', authDocs);
}


var isChrome = navigator.userAgent.toLowerCase().indexOf('chrome') > -1;
var isSafari = navigator.userAgent.toLowerCase().indexOf('safari') > -1;
$('.downloadDocs').click(() => {
  mark.markPoint('copyright_org_download');
  let sUrl = authDocs;
  if (/(iP)/g.test(navigator.userAgent)) {
    alert('抱歉，iOS 设备不支持下载文件');
    return false;
  }
  if (isChrome || isSafari) {
    const link = document.createElement('a');
    link.href = sUrl;
    if (link.download !== undefined) {
      const fileName = sUrl.substring(sUrl.lastIndexOf('/') + 1, sUrl.length);
      link.download = fileName || '媒体大脑.mp3';
    }
    if (document.createEvent) {
      const e = document.createEvent('MouseEvents');
      e.initEvent('click', true, true);
      link.dispatchEvent(e);
      return true;
    }
  }
  if (sUrl.indexOf('?') === -1) {
    sUrl += '?download';
  }
  window.open(sUrl, '_self');
});



// WEBPACK FOOTER //
// ./src/pages/signup/app.js